import { ArrayToLookupByKey } from "global/Utility/TSFunctions";
import { CoverageMapping, ICoverageMapper } from "global/Validation/DataValidation";
import { IFeesAndPremiums, IFlexibleField, IGroupConfigurationConfig, IGroupConfigurationData } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";
/**
 * Updates attribute sort order and adds in any missing attributes given by the release.
 * NOTE: If fields no longer exist (which shouldn't happen), the fields will be appended
 * to the end of the field array (ensuring no data loss).
 */
export class UpdateFeesAndPremiumCoverageTransformer extends BaseJsonTransformer {
    readonly map: Record<string, ICoverageMapper>;

    constructor(release: IGroupConfigurationConfig) {
        super();

        this.map = ArrayToLookupByKey(CoverageMapping, 'fnp_attributeId');
    }

    async transformFeesAndPremium(feesAndPremium: IFeesAndPremiums): Promise<boolean | void> {
        this.processFields(feesAndPremium.fields);
    }

    processFields(sourceFields: IFlexibleField[]): void {

        sourceFields.forEach(eachField => {

            const isCoverageField = this.map[eachField.configRef.id];

            if (isCoverageField) {
                if (eachField.values.length === 1) {
                    if (eachField.values[0].value === null) {
                        eachField.values[0].value = {
                            type: 'bool',
                            value: false,
                        }
                    }
                }
            }
        });
    }
}
